export const NUMBER_OF_COLUMNS = 12 as const
